import { useSetMyAvailability } from './hooks'
import type { AvailabilityStatus, AvailabilityView } from './types'
import { STATUS_LABELS } from './types'

const STATUS_OPTIONS: AvailabilityStatus[] = ['READY', 'BUSY', 'AWAY']

const STATUS_STYLES: Record<AvailabilityStatus, string> = {
  READY: 'bg-emerald-100 text-emerald-700 hover:bg-emerald-200',
  BUSY: 'bg-amber-100 text-amber-700 hover:bg-amber-200',
  AWAY: 'bg-slate-100 text-slate-700 hover:bg-slate-200',
}

const STATUS_ACTIVE: Record<AvailabilityStatus, string> = {
  READY: 'ring-2 ring-emerald-500',
  BUSY: 'ring-2 ring-amber-500',
  AWAY: 'ring-2 ring-slate-400',
}

interface Props {
  availability: AvailabilityView
}

/**
 * Single row in MyAvailabilityWidget - team name + 3 status buttons (Gotowy /
 * Zajęty / Niedostępny). Klik = mutation, current status shown by ring.
 */
export function TeamAvailabilityRow({ availability }: Props) {
  const set = useSetMyAvailability()
  const isPending = set.isPending

  return (
    <li className="px-3 py-2.5 flex flex-col gap-1.5">
      <span className="text-sm font-medium truncate" title={availability.teamCode}>
        {availability.teamName}
      </span>
      <div className="flex gap-1">
        {STATUS_OPTIONS.map(s => (
          <button
            key={s}
            type="button"
            disabled={isPending}
            onClick={() => set.mutate({ teamId: availability.teamId, status: s })}
            className={`flex-1 text-xs py-1 rounded transition-colors disabled:opacity-50
              ${STATUS_STYLES[s]}
              ${availability.status === s ? STATUS_ACTIVE[s] : ''}`}
          >
            {STATUS_LABELS[s]}
          </button>
        ))}
      </div>
    </li>
  )
}
